/**
 * Centralized localStorage keys enum
 * This is in a separate file to avoid circular dependencies
 */
export enum LocalStorageKeys {
  ACTIVE_WORKSPACE = 'activeWorkspace',
  AUDIT_TRAIL_COLUMNS = 'auditTrailColumns',
  EULA_ACCEPTED = 'eulaAccepted',
  OIDC_KEY = 'oidcKey',
  VALID_HOSTS = 'validHosts',
}
